import { map } from "rxjs";
import { Offer } from "../../model";
import apiService from "../ApiService";

const getOffers = (lang: string, countryCode: string) => {
  return apiService
    .get<{ offers: Offer[] }>({
      path: `public/offers`,
      params: {
        lang,
        countryCode,
      },
      crm: true,
    })
    .pipe(map(({ offers }) => offers));
};
export { getOffers };
